import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Pencil, Trash2 } from "lucide-react";
import type { PricingCategory } from "./PricingCategoryTabs";

const dayNames = ["Mån", "Tis", "Ons", "Tor", "Fre", "Lör", "Sön"];

interface Props {
  rules: any[];
  categories: PricingCategory[];
  onEdit: (rule: any) => void;
  onDelete: (id: string) => void;
}

export default function PricingRuleList({ rules, categories, onEdit, onDelete }: Props) {
  const catLabel = (key: string) => categories.find((c) => c.key === key)?.label ?? key;

  if (rules.length === 0) {
    return <p className="text-sm text-muted-foreground text-center py-8">Inga prisregler för denna kategori.</p>;
  }

  return (
    <div className="space-y-2">
      {rules.map((rule) => (
        <Card key={rule.id}>
          <CardContent className="p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="h-4 w-4 rounded-full shrink-0 border" style={{ backgroundColor: rule.color }} />
              <div>
                <div className="flex items-center gap-2">
                  <span className="font-medium text-sm">{rule.name}</span>
                  <Badge variant={rule.is_peak ? "default" : "secondary"} className="text-[10px]">
                    {rule.is_peak ? "Peak" : "Off-peak"}
                  </Badge>
                  <Badge variant="outline" className="text-[10px]">{catLabel(rule.category)}</Badge>
                </div>
                <p className="text-xs text-muted-foreground mt-0.5">
                  {rule.start_time?.slice(0, 5)}–{rule.end_time?.slice(0, 5)} · {rule.price_per_hour} kr/h
                </p>
                {rule.day_of_week && rule.day_of_week.length > 0 && (
                  <p className="text-xs text-muted-foreground">
                    {rule.day_of_week.map((d: number) => dayNames[d - 1]).join(", ")}
                  </p>
                )}
              </div>
            </div>
            <div className="flex gap-1">
              <Button variant="ghost" size="icon" onClick={() => onEdit(rule)}><Pencil className="h-4 w-4" /></Button>
              <Button variant="ghost" size="icon" onClick={() => onDelete(rule.id)}><Trash2 className="h-4 w-4 text-destructive" /></Button>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
